<div class="krd-backdrop" (click)="close()" aria-hidden="true"></div>
<section class="krd-modal" role="dialog" aria-modal="true" aria-labelledby="krd-title">
  <button type="button" class="krd-close" (click)="close()" [disabled]="busy()" [attr.aria-label]="'common.close' | translate">
    <svg viewBox="0 0 14 14" width="12" height="12"><path d="M3 3 L11 11 M11 3 L3 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
  </button>

  <header class="krd-head">
    <span class="krd-eyebrow"><span class="krd-eyebrow-dot"></span>{{ 'knowledge.review.eyebrow' | translate }}</span>
    <h2 id="krd-title" class="krd-title">{{ review()?.filename || ('knowledge.review.title' | translate) }}</h2>
    <p class="krd-sub">{{ 'knowledge.review.sub' | translate }}</p>
  </header>

  <div class="krd-body">
    @if (loading() && !review()) {
      <p class="krd-message">{{ 'knowledge.files.loading' | translate }}</p>
    } @else if (loadError(); as err) {
      <p class="krd-message krd-error">{{ err }}</p>
    } @else if (review(); as r) {

      <!-- Informe de procesado -->
      <div class="krd-report" [attr.data-semaphore]="r.report.semaphore">
        <div class="krd-report-head">
          <span class="krd-semaphore" [attr.data-semaphore]="r.report.semaphore">
            <span class="krd-semaphore-dot"></span>{{ 'knowledge.review.semaphore.' + r.report.semaphore | translate }}
          </span>
          <span class="krd-report-line">
            {{ 'knowledge.review.report.summary' | translate: {
              sections: r.report.totals.sections, withRules: r.report.totals.withRules,
              valid: r.report.totals.valid, proposed: r.report.totals.proposed } }}
          </span>
        </div>

        <ul class="krd-sections">
          <li>
            <button type="button" class="krd-section-name" [class.on]="section() === null" (click)="filterSection(null)">
              {{ 'knowledge.review.allSections' | translate }}
              <span class="krd-count">{{ r.totalClaims }}</span>
            </button>
          </li>
          @for (s of r.report.sections; track s.section) {
            <li [attr.data-status]="s.status">
              @if (s.claimIndexes.length) {
                <input type="checkbox" class="krd-check"
                       [checked]="isSectionApproved(s)" [disabled]="busy()"
                       [attr.aria-label]="'knowledge.claimReview.sectionAcceptAll' | translate"
                       (change)="toggleSection(s)" />
                <button type="button" class="krd-section-name" [class.on]="section() === s.section" (click)="filterSection(s.section)">
                  {{ sectionLabel(s.section) }}
                  <span class="krd-count">{{ s.claimIndexes.length }}</span>
                </button>
              } @else {
                <span class="krd-check-gap"></span>
                <span class="krd-section-name krd-section-static">{{ sectionLabel(s.section) }}</span>
              }
              <span class="krd-status" [attr.data-status]="s.status" [title]="s.detail || ''">
                {{ 'knowledge.review.section.' + s.status | translate }}
              </span>
              @if (s.status === 'error' && s.detail) {
                <small class="krd-detail">{{ s.detail }}</small>
              }
            </li>
          }
        </ul>

        @if (needsAcceptance()) {
          <label class="krd-accept">
            <input type="checkbox" [checked]="acceptErrors()" [disabled]="busy()"
                   (change)="acceptErrors.set(!acceptErrors())" />
            <span>{{ 'knowledge.review.acceptErrors' | translate: { n: sectionErrors() } }}</span>
          </label>
        }
      </div>

      <!-- Claims de la página -->
      <div class="krd-toolbar">
        <span class="krd-approved">
          {{ 'knowledge.review.approvedCount' | translate: { n: approvedCount(), total: total() } }}
          @if (editedCount()) { · {{ 'knowledge.review.editedCount' | translate: { n: editedCount() } }} }
        </span>
        @if (deselected().size) {
          <button type="button" class="krd-link" (click)="approveAll()" [disabled]="busy()">
            {{ 'knowledge.review.approveAll' | translate }}
          </button>
        }
      </div>

      @if (!r.claims.length) {
        <p class="krd-message">{{ 'knowledge.review.noClaims' | translate }}</p>
      } @else {
        <ul class="krd-claims" [class.krd-loading]="loading()">
          @for (c of pageClaims(); track c.index) {
            <li class="krd-claim" [class.off]="!isApproved(c.index)" [class.edited]="isEdited(c.index)">
              @if (draft(); as d) {
                @if (d.index === c.index) {
                  <!-- Edición completa de la claim -->
                  <div class="krd-edit">
                    <label class="krd-field">
                      <span>{{ 'knowledge.review.edit.text' | translate }}</span>
                      <textarea rows="3" [value]="d.text"
                                (input)="patchDraft({ text: $any($event.target).value })"></textarea>
                    </label>

                    <div class="krd-row">
                      <label class="krd-field">
                        <span>{{ 'knowledge.review.edit.type' | translate }}</span>
                        <select [value]="d.claimType" (change)="patchDraft({ claimType: $any($event.target).value })">
                          @for (t of claimTypes; track t) {
                            <option [value]="t" [selected]="t === d.claimType">{{ claimTypeLabel(t) }}</option>
                          }
                        </select>
                      </label>
                      <label class="krd-field">
                        <span>{{ 'knowledge.review.edit.polarity' | translate }}</span>
                        <select [value]="d.polarity" (change)="patchDraft({ polarity: $any($event.target).value })">
                          @for (p of polarities; track p) {
                            <option [value]="p" [selected]="p === d.polarity">{{ 'knowledge.review.polarity.' + p | translate }}</option>
                          }
                        </select>
                      </label>
                      <label class="krd-field krd-field-narrow">
                        <span>{{ 'knowledge.review.edit.confidence' | translate }}</span>
                        <input type="number" min="0.5" max="1" step="0.05" [value]="d.confidence"
                               (input)="patchDraft({ confidence: +$any($event.target).value })" />
                      </label>
                    </div>

                    <div class="krd-entities">
                      <span class="krd-entities-title">{{ 'knowledge.review.edit.entities' | translate }}</span>
                      @for (e of d.entities; track $index) {
                        <div class="krd-entity-row">
                          <select [value]="e.kind" (change)="patchEntity($index, { kind: $any($event.target).value })"
                                  [attr.aria-label]="'knowledge.review.edit.entityKind' | translate">
                            @for (k of entityKinds; track k) {
                              <option [value]="k" [selected]="k === e.kind">{{ 'knowledge.review.kind.' + k | translate }}</option>
                            }
                          </select>
                          <input type="text" [value]="e.surface" [placeholder]="'knowledge.review.edit.entitySurface' | translate"
                                 (input)="patchEntity($index, { surface: $any($event.target).value })" />
                          <input type="text" [value]="e.normalized" [placeholder]="'knowledge.review.edit.entityNormalized' | translate"
                                 (input)="patchEntity($index, { normalized: $any($event.target).value })" />
                          <select [value]="e.roleInClaim" (change)="patchEntity($index, { roleInClaim: $any($event.target).value })"
                                  [attr.aria-label]="'knowledge.review.edit.entityRole' | translate">
                            @for (ro of entityRoles; track ro) {
                              <option [value]="ro" [selected]="ro === e.roleInClaim">{{ 'knowledge.review.role.' + ro | translate }}</option>
                            }
                          </select>
                          <button type="button" class="krd-icon" (click)="removeEntity($index)"
                                  [attr.aria-label]="'knowledge.review.edit.removeEntity' | translate">×</button>
                        </div>
                      }
                      <button type="button" class="krd-link" (click)="addEntity()" [disabled]="d.entities.length >= 8">
                        + {{ 'knowledge.review.edit.addEntity' | translate }}
                      </button>
                    </div>

                    @if (draftError(); as err) { <p class="krd-message krd-error">{{ err }}</p> }
                    <div class="krd-edit-actions">
                      <button type="button" class="krd-btn ghost" (click)="cancelEdit()">{{ 'common.cancel' | translate }}</button>
                      <button type="button" class="krd-btn primary" (click)="saveEdit()">{{ 'knowledge.review.edit.save' | translate }}</button>
                    </div>
                  </div>
                } @else {
                  <ng-container *ngTemplateOutlet="claimRow; context: { $implicit: c }"></ng-container>
                }
              } @else {
                <ng-container *ngTemplateOutlet="claimRow; context: { $implicit: c }"></ng-container>
              }
            </li>
          }
        </ul>

        <!-- Páginas -->
        @if (r.pageCount > 1) {
          <nav class="krd-pager" [attr.aria-label]="'knowledge.review.pager' | translate">
            <button type="button" class="krd-btn ghost" (click)="goTo(r.page - 1)" [disabled]="r.page <= 1 || busy() || !!draft()">
              ‹ {{ 'knowledge.review.prev' | translate }}
            </button>
            <span class="krd-pager-info">{{ 'knowledge.review.pageOf' | translate: { page: r.page, pages: r.pageCount } }}</span>
            <button type="button" class="krd-btn ghost" (click)="goTo(r.page + 1)" [disabled]="r.page >= r.pageCount || busy() || !!draft()">
              {{ 'knowledge.review.next' | translate }} ›
            </button>
          </nav>
        }
      }
    }

    @if (writing()) {
      <p class="krd-message">{{ 'knowledge.review.writing' | translate }}</p>
    }
    @if (actionError(); as err) {
      <p class="krd-message krd-error" role="alert">{{ err }}</p>
    }
  </div>

  <footer class="krd-foot">
    @if (confirmingDiscard()) {
      <span class="krd-discard-q">{{ 'knowledge.review.discardQuestion' | translate }}</span>
      <button type="button" class="krd-btn ghost" (click)="cancelDiscard()" [disabled]="busy()">{{ 'common.cancel' | translate }}</button>
      <button type="button" class="krd-btn danger" (click)="discard()" [disabled]="busy()">
        {{ 'knowledge.review.discardConfirm' | translate }}
      </button>
    } @else {
      <button type="button" class="krd-btn ghost danger-text" (click)="askDiscard()" [disabled]="busy() || !review()">
        {{ 'knowledge.review.discard' | translate }}
      </button>
      <span class="krd-spacer"></span>
      <button type="button" class="krd-btn ghost" (click)="close()" [disabled]="busy()">{{ 'common.close' | translate }}</button>
      <button type="button" class="krd-btn primary" (click)="confirm()" [disabled]="!canConfirm()">
        {{ (busy() ? 'knowledge.claimReview.confirmButtonSaving' : 'knowledge.claimReview.confirmButton') | translate: { count: approvedCount() } }}
      </button>
    }
  </footer>
</section>

<!-- Una claim en modo lectura -->
<ng-template #claimRow let-c>
  <input type="checkbox" class="krd-check" [checked]="isApproved(c.index)" [disabled]="busy()"
         [attr.aria-label]="c.text" (change)="toggleClaim(c.index)" />
  <div class="krd-claim-main">
    <p class="krd-claim-text">{{ c.text }}</p>
    <small class="krd-meta">
      {{ claimTypeLabel(c.claimType) }} · {{ 'knowledge.review.polarity.' + c.polarity | translate }}
      · {{ c.confidence | number: '1.0-2' }}
      @if (!section()) { · {{ sectionLabel(c.section) }} }
      @for (e of c.entities; track $index) {
        <span class="krd-badge" [class.new]="entityStatus(e) === 'new'" [class.existing]="entityStatus(e) === 'existing'">
          {{ e.surface || e.normalized }}
          @if (entityStatus(e); as st) { · {{ (st === 'new' ? 'knowledge.claimReview.entityNew' : 'knowledge.claimReview.entityExisting') | translate }} }
        </span>
      }
      @if (isEdited(c.index)) { <span class="krd-edited">{{ 'knowledge.review.edited' | translate }}</span> }
    </small>
  </div>
  <div class="krd-claim-actions">
    <button type="button" class="krd-link" (click)="startEdit(c)" [disabled]="busy() || !!draft()">
      {{ 'knowledge.review.edit.button' | translate }}
    </button>
    @if (isEdited(c.index)) {
      <button type="button" class="krd-link" (click)="restore(c.index)" [disabled]="busy() || !!draft()">
        {{ 'knowledge.review.edit.restore' | translate }}
      </button>
    }
  </div>
</ng-template>
